/* Global imports. */
import React from "react";

interface Props {
  name: string;
  website?: string;
}

const ArticleContributor = ({ name, website }: Props) => <span className="">by { website ? <a href={`${website}`} data-contributor={name} data-website={website} target="_blank" rel="noreferrer" className="underline hover:text-[#999] transition-all ease-linear duration-300">{name}</a> : name }</span>

export default ArticleContributor;
